import React from "react"
import {connect} from "react-redux";
import PropTypes from "prop-types"
import BrowseView from "../../browse/BrowseView";
import {bindActionCreators} from "redux";
import * as SelectionActions from "../../reducers/selection"
import {Row, Col, Button} from "antd"
import {NavLink} from "react-router-dom"
import SelectionTable from "./SelectionTable";


class SelectionView extends React.Component {
    static propTypes = {
        selections: PropTypes.array.isRequired,
        persons: PropTypes.array.isRequired,
        fetchingSelections: PropTypes.bool.isRequired,
        search: PropTypes.func.isRequired
    };

    state = {
        selectedRowKeys: []
    };

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    };

    render() {
        const {getSelections, fetchingSelections, search, persons} = this.props;
        const {selectedRowKeys} = this.state;
        const selectedId = selectedRowKeys[0];
        const disabled = selectedRowKeys.length === 0;
        const titleBar = <Row>
            <Col span={4}>Selection Index</Col>
            <Col span={1} offset={19}>
                <NavLink to={`/browse/selection/${selectedId}`}>
                    <Button type='primary' disabled={disabled}>Open</Button>
                </NavLink>
            </Col>
        </Row>
        return <BrowseView
            masterTitle={titleBar}
            master={<SelectionTable dataSource={persons} onSelectChange={this.onSelectChange}
                                    loading={fetchingSelections} compact={false}/>}
            initialQuery={getSelections}
            searchableProps={["selection"]}
            searchLogic={search}
            loading={fetchingSelections}
        />
    }
}

const mapStateToProps = state => ({
    persons: state.selection.selections,
    fetchingPersons: state.selection.fetchingSelections
});

const mapDispatchToProps = dispatch => ({
    getSelections: bindActionCreators(SelectionActions, dispatch).getSelections,
    search: bindActionCreators(SelectionActions, dispatch).search

});

export default connect(mapStateToProps, mapDispatchToProps)(SelectionView)



// WEBPACK FOOTER //
// ./src/js/browse/selection/SelectionView.js